import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PAYMENTPAGE_LEGACY_FIELD_ORDER = [
  "background_color",
  "background_image"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  paymentPageDescriptor: _generatedPaymentPageDescriptor,
  paymentPageBlocDefinition,
  paymentPageDashboardLayout,
  paymentPageConfig,
  paymentPageResolveConfig,
  paymentPageProperties,
} = doodBlockConfig(
  {
    name: "Payment page",
    internal_name: "Payment page",
    url: "payment",
    defaultParent: [/^Main Layout$/i],
    componentType: 'PaymentPageComponent',
    category: 'page',
    description: "Payment page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.payment-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'payment-header-block', type: 'PaymentPageHeaderBlockComponent' },
          { id: 'payment-method-picker-block', type: 'PaymentMethodPickerBlockComponent' },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.payment-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.payment-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.payment-page.background-image.label",
        help: "pages.blocks.payment-page.background-image.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.payment-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.payment-page.fieldset.appearance.label",
            fields: ["background_color", "background_image"],
          },
          {
            legend: "pages.blocks.payment-page.fieldset.blocks.label",
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function paymentPageDescriptor(): IBlockDescriptor;
export function paymentPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function paymentPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPaymentPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPaymentPageDescriptor, paymentPageProperties, fieldOrder);
}

export {
  paymentPageBlocDefinition,
  paymentPageDashboardLayout,
  paymentPageProperties,
  paymentPageConfig,
  paymentPageResolveConfig,
};

export type PaymentPageConfig = typeof paymentPageConfig;
